class AppConfig {
    static readonly apiUrl = "https://api.dynsign.com";
    // static readonly apiUrl = "http://127.0.0.1:8787";
    
}

export { AppConfig };